export const makeSerializable = (payload: Record<string, unknown>) =>
    JSON.parse(JSON.stringify(payload));

export const getSegmentAverage = (segment: string): number => {
    const match = segment.match(/^(\d+)-(\d+)$/);

    if (!match) {
        throw new Error('Segment must be in format "X-Y"');
    }

    const lower = Number(match[1]);
    const upper = Number(match[2]);

    return (lower + upper) / 2;
};


export const getSegment = (value: number): string  => {
    if (value < 0 || value > 100) {
        throw new Error('Value must be between 0 and 100');
    }

    if (value === 100) {
        return '90-100';
    }

    const lowerBound = Math.floor(value / 10) * 10;
    const upperBound = lowerBound + 10;

    return `${lowerBound}-${upperBound}`;
};
